import { useCallback, useContext, useMemo } from 'react';
import { ProductTableContext } from '../../../contexts/product-table-context';
import type { Product } from '../../../data/product';
import {
  type StringOption,
  stringOptionsToValues,
  useStringOptions,
} from '../../../helpers/string-options';
import type { Filters } from '../../../hooks/products';
import { MultiSelect } from '../../forms';
import { withFilterField } from './filter-component';
import { FilterWrapper } from './filter-wrapper';

export const DepartmentFilter = withFilterField(
  'departments',
  function DepartmentFilter({ products }: { products: Product[] }) {
    const { filters, setFilters } = useContext(ProductTableContext);
    const { departments } = filters;

    const options: StringOption[] = useMemo(() => {
      const departments = new Set<string>();
      for (const product of products) {
        departments.add(product.department);
      }

      //convert set to array, remove blank items
      return [...departments]
        .filter((department) => department.trim() !== '')
        .sort()
        .map((department) => ({ value: department, label: department }));
    }, [products]);

    const value = useStringOptions(departments);

    const onChange = useCallback(
      (departmentOptions: readonly StringOption[]) => {
        const departments = stringOptionsToValues(departmentOptions);
        setFilters((prev: Filters) => ({ ...prev, departments }));
      },
      [setFilters]
    );

    return (
      <FilterWrapper label="Department">
        <MultiSelect
          options={options}
          value={value}
          onChange={onChange}
          placeholder="Any"
          isMulti
        />
      </FilterWrapper>
    );
  }
);
